import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import * as types from '../../actions/actionTypes';
import ExternalLink from '../ExternalLink';
import CloudFrontPicture from '../image/CloudFrontPicture';
import InternalLink from '../InternalLink';
import Container from './IframeContainer';


class YouTubeVid extends Component {

    state = {
        loadVid: false,
    };

    handleClick = () => {
        this.setState({ loadVid: true });
    };

    render() {
        const Preview =
            (
                <div className='container'>
                    <div className='consent' onClick={this.handleClick}>Zum
                        Schutz
                        Deiner Daten ist das YouTube Video blockiert. Wenn Du
                        auf
                        "Video anzeigen" klickst, akzeptierst Du
                        unsere <InternalLink
                            className='stolo-footer-link'
                            to={{ type: types.NAVIGATED_TO_PRIVACY }}
                            rel='nofollow'
                        ><span>Daten</span>schutz<span>richtlinie</span>
                        </InternalLink> und die <ExternalLink
                            href='https://policies.google.com/privacy?hl=de&gl=de'
                            target='_blank'
                        >Datenschutzbestimmungen von
                            YouTube</ExternalLink>.
                        <p>
                            <Button
                                variant='contained' size='small' color='secondary'
                                classes={{ sizeSmall: 'schnoffle-button-small' }}
                                onClick={this.handleClick}
                            >
                                Video laden
                            </Button>
                        </p>
                    </div>
                    <CloudFrontPicture
                        src='youtube-schnoffle-1.png'
                        webp='youtube-schnoffle-1.webp' png
                        schnoffle
                        altText='Schnoffle Youtube Video'
                    />
                </div>
            );

        return (
            <Container>
                {this.state.loadVid ?
                    <iframe
                        width='560' height='315'
                        src='https://www.youtube-nocookie.com/embed/pEneg4Frls0'
                        frameBorder='0'
                        allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                    /> : Preview
                }
            </Container>
        );
    }

}


export default YouTubeVid;



// WEBPACK FOOTER //
// ./src/components/home/YouTubeVid.js